import { useMutation } from "react-query";
import { postUpdateItemShoppingBag } from "../requests/ShoppingBag";
import logger from "components/Logger";
import { queryClient } from "../../queries";
import { API_SHOPPING_BAG_QUERY_KEY } from "../queries/useQueryShoppingBag";

const path = 'src/services/api/mutations/useMutationUpdateItemShoppingBag.ts'

export const MUTATION_UPDATE_ITEM_QUERY_KEY = 'useMutationAddItemShoppingBag'

export function useMutationItemUpdateShoppingBag() {
    return useMutation(postUpdateItemShoppingBag, {
        mutationKey: 'MUTATION_UPDATE_ITEM_QUERY_KEY',
        onMutate: async (newItem) => {
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries(API_SHOPPING_BAG_QUERY_KEY)

        },
        onSuccess: (data) => {
            if (data?.success) {
                // console.log(data?.data);
                //queryClient.invalidateQueries("apiShoppingBag")
                logger.log("************************************************************************************")
                logger.log(`| FILE: ${path} | METHOD: useMutationItemUpdateShoppingBag`)
                logger.log("| onSuccess |")
                logger.log("| data.data: ", data.data)
                logger.log("************************************************************************************");

                queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
            } else {
                // console.log(data?.errors);
            }
        },
        onError: (data) => {
            // console.error(data);
        },
        onSettled: (data) => {
            queryClient.invalidateQueries(API_SHOPPING_BAG_QUERY_KEY)
        }
    });
}
